/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { BroadcastMsgListDto } from '../../models/broadcast-msg-list-dto';

export interface GetBroadcastMessages$Params {
  /**
   * If not provided or empty, will only return messages for all audiences
   */
  audience?: Array<'All' | 'Property' | 'Survey Marks' | 'VICNAMES'>;

  /**
   * If provided, will only return messages created after this time
   */
  start_time?: string;
}

export function getBroadcastMessages(
  http: HttpClient,
  rootUrl: string,
  params?: GetBroadcastMessages$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<BroadcastMsgListDto>> {
  const rb = new RequestBuilder(rootUrl, getBroadcastMessages.PATH, 'get');
  if (params) {
    rb.query('audience', params.audience, {});
    rb.query('start_time', params.start_time, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BroadcastMsgListDto>;
      }),
    );
}

getBroadcastMessages.PATH = '/message';
